import { useGetAllRecipientUsageHistory } from "@features/ux/components/recipientList/hooks";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";
import { MODAL_PAGE_SIZE } from "@shared/utils/constants";
import React, { useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const HistoryList = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  // Read page from URL
  const currentPage = parseInt(searchParams.get("page") || "1");

  // Update hook to accept pagination parameters
  const { data: usageHistoryList } = useGetAllRecipientUsageHistory(
    Number(id),
    currentPage,
    MODAL_PAGE_SIZE
  );

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: MODAL_PAGE_SIZE,
    startItem: 0,
    endItem: 0,
  });

  // Update pagination - same structure as RecipientList
  React.useEffect(() => {
    const totalItems = usageHistoryList?.count || 0;
    const totalPages = Math.ceil(totalItems / MODAL_PAGE_SIZE);
    const startItem = (currentPage - 1) * MODAL_PAGE_SIZE + 1;
    const endItem = Math.min(currentPage * MODAL_PAGE_SIZE, totalItems);

    setPagination({
      currentPage: currentPage,
      totalPages,
      totalItems,
      itemsPerPage: MODAL_PAGE_SIZE,
      startItem: totalItems > 0 ? startItem : 0,
      endItem: totalItems > 0 ? endItem : 0,
    });
  }, [usageHistoryList, currentPage]);

  const handlePageChange = (page: number) => {
    const newParams: Record<string, string> = {
      ...Object.fromEntries(searchParams.entries()),
      page: page.toString(),
    };
    setSearchParams(newParams);
  };

  const columns = useMemo<TableColumn<any>[]>(
    () => [
      {
        key: "",
        header: "Date",
        sortable: true,
      },
      {
        key: "",
        header: "Time",
        sortable: true,
      },
      {
        key: "",
        header: "Channel",
        sortable: true,
      },
      {
        key: "",
        header: "Template Name",
        sortable: true,
      },
      {
        key: "",
        header: "Status",
        sortable: true,
        render: (value) => (
          <span
            className={
              value === "Scheduled"
                ? "text-green-600"
                : value === "Completed"
                ? "text-red-600"
                : "text-gray-600"
            }
          >
            {value}
          </span>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <h2 className="text-sm font-bold">Usage History</h2>
      <div className="space-y-4 mt-4">
        <GenericTable
          data={usageHistoryList?.results || []}
          columns={columns}
          rowKey="id"
          emptyMessage="No usage history found"
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default HistoryList;